import financeiroApi from '../financeiroApi';

const PATH = '/api/v1/backend/fiscal/cst';

export default {
  buscarCst: async (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  pesquisarCstSituacao: async (params) => {
    return financeiroApi.get(`${PATH}/situacao/pesquisar`, { params });
  },

  pesquisarCstClassificacao: async (params) => {
    return financeiroApi.get(`${PATH}/classificacao/pesquisar`, { params });
  },
};
